import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FecImportFileListSkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S8} ${Spacing.S12};
  border-radius: ${BorderRadius.R8};
  background-color: ${Color.Grey50};
`

export const FecImportFileListSkeletonTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S2};
`
